const socialLinks: {
  href: string;
  ariaLabel: string;
  icon: string;
}[] = [
  {
    href: "https://github.com/YanivWein24/",
    ariaLabel: "My Github",
    icon: "fa-brands fa-github",
  },
  {
    href: "https://www.linkedin.com/in/yaniv-weinshtein/",
    ariaLabel: "My Linkedin",
    icon: "fa-brands fa-linkedin",
  },
  {
    href: "mailto:Yanivwein22@gmail.com",
    ariaLabel: "My Email",
    icon: "fa-solid fa-envelope",
  },
];

export default socialLinks;
